import requests from '../../api/client'
import { normalizeHttpFailure } from '../../api/normalizeApiError'
import { HttpAnswer, HttpResult, PurchaseSummaryParams } from '../../types/otp'

export default async function checkoutSummary(
  hash: string
): Promise<HttpResult<PurchaseSummaryParams>> {
  const response = (await requests.checkoutSummary(hash)) as HttpAnswer & { headers?: unknown }
  const status = response?.status ?? 200
  const body = (response?.data ?? response) as PurchaseSummaryParams

  // Fora do 2xx o corpo é o envelope de erro, não PurchaseSummaryParams: sem
  // isto o cast acima era cego e a mensagem da API se perdia.
  if (status < 200 || status >= 300) {
    return { status, body, error: normalizeHttpFailure(status, response?.data, response?.headers) }
  }

  return { status, body }
}
